import type { GetPasskeyAuthenticationOptionsResponse } from '@dynamic-labs/sdk-api-core';
import type { PublicKeyCredentialRequestOptionsJSON } from '@simplewebauthn/browser';

import { getCore } from '../../../../client/core/getCore';
import type { DynamicClient } from '../../../../client/types';
import { createApiClient } from '../../../apiClient';

export type GetPasskeyAuthenticationSignInOptionsParams = {
  relatedOriginRpId?: string;
};

export const getPasskeyAuthenticationSignInOptions = async (
  { relatedOriginRpId }: GetPasskeyAuthenticationSignInOptionsParams = {},
  client: DynamicClient
): Promise<PublicKeyCredentialRequestOptionsJSON> => {
  const core = getCore(client);

  const apiClient = createApiClient({}, client);

  const options: GetPasskeyAuthenticationOptionsResponse =
    await apiClient.getPasskeyAuthenticationSigninOptions({
      environmentId: core.environmentId,
      relatedOriginRpId: relatedOriginRpId,
    });

  return options as PublicKeyCredentialRequestOptionsJSON;
};
